
<h2 class="text-primary">{{_scanResult.scanConfigurationName}}</h2>

<cw-ci-data-table #resultRulesDataTable
  tileTitle="Rules"
  defaultSortField="definition_id"
  defaultSortDirection="desc"
  skipInitialLoad="true"
  paginateResults="false"
  [isSelectable]="isSelectable"
  (loadItemsHandler)="loadScanResults($event)"
  (selectHandler)="selectRule($event)"
  [items]="definitionResults">

  <cw-ci-table-column columnName="definition_id" columnTitle="Definition" [output]="ruleTemplate" sortField="definition_id"></cw-ci-table-column>
  <ng-template let-element #ruleTemplate>{{element.title}}<br><span class="text-accent">{{element.definition_id}}</span></ng-template>
  <cw-ci-table-column columnName="references" columnTitle="References" [output]="referencesTemplate" minWidth="150px"></cw-ci-table-column>
  <ng-template let-element #referencesTemplate>
    <div style="display: flex; flex-direction: column">
      <a mat-stroked-button class="small" style="margin-top:4px;" color="primary" *ngFor="let identifier of element.references" (click)="openReference($event, identifier);">{{identifier}}</a>
    </div>
  </ng-template>
  <cw-ci-table-column columnName="result" columnTitle="Result" sortField="result" [output]="resultTemplate" minWidth="150px"></cw-ci-table-column>
  <ng-template let-element #resultTemplate>
    <div [style.color]="(element.result == 'true') ? 'green' : (element.result == 'false') ? 'red' : 'blue'">
      <mat-icon svgIcon="cw:flag_risk" style="vertical-align:middle"></mat-icon><span style="vertical-align:middle">{{element.result}}</span>
    </div>
  </ng-template>
</cw-ci-data-table>